export const IntentionalityIcon = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    width='32'
    height='36'
    viewBox='0 0 32 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_12_210)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M30.2081 28.3178L30.2328 28.3031C30.7899 27.9684 31.1975 27.4313 31.3713 26.8031C31.545 26.1748 31.4716 25.5035 31.1663 24.9281L28.2607 19.3922L6.38184 30.9792L14.2081 35.5178C14.753 35.8337 15.371 36 16.0001 36C16.6292 36 17.2472 35.8337 17.7921 35.5178L30.2081 28.3178Z'
        fill='#4568A5'
      />
      <mask
        id='mask0_12_210'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='6'
        y='19'
        width='26'
        height='17'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M30.2081 28.3178L30.2328 28.3031C30.7899 27.9684 31.1975 27.4313 31.3713 26.8031C31.545 26.1748 31.4716 25.5035 31.1663 24.9281L28.2607 19.3922L6.38184 30.9792L14.2081 35.5178C14.753 35.8337 15.371 36 16.0001 36C16.6292 36 17.2472 35.8337 17.7921 35.5178L30.2081 28.3178Z'
          fill='#4568A5'
        />
      </mask>
      <g mask='url(#mask0_12_210)'>
        <g
          style={{ mixBlendMode: 'darken' }}
          opacity='0.3'
          filter='url(#filter0_f_12_210)'
        >
          <ellipse
            cx='34.5841'
            cy='25.5256'
            rx='8.72528'
            ry='14'
            transform='rotate(-11.6772 34.5841 25.5256)'
            fill='black'
          />
        </g>
      </g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.93965 22.3465L21.4939 2.62827L17.792 0.482044C17.2471 0.166168 16.6291 -0.00012207 16 -0.00012207C15.3709 -0.00012207 14.7528 0.166168 14.208 0.482044L1.792 7.68204C1.24714 7.99802 0.794686 8.45251 0.480123 8.99981C0.16556 9.54711 -2.89523e-05 10.1679 3.79695e-09 10.7999V13.4999C1.10583e-05 15.1698 0.350932 16.8209 1.02982 18.3452C1.7087 19.8695 2.70026 21.2327 3.93965 22.3456V22.3465Z'
        fill='#4568A5'
      />
      <mask
        id='mask1_12_210'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='-1'
        width='22'
        height='24'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.93965 22.3465L21.4939 2.62827L17.792 0.482044C17.2471 0.166168 16.6291 -0.00012207 16 -0.00012207C15.3709 -0.00012207 14.7528 0.166168 14.208 0.482044L1.792 7.68204C1.24714 7.99802 0.794686 8.45251 0.480123 8.99981C0.16556 9.54711 -2.89523e-05 10.1679 3.79695e-09 10.7999V13.4999C1.10583e-05 15.1698 0.350932 16.8209 1.02982 18.3452C1.7087 19.8695 2.70026 21.2327 3.93965 22.3456V22.3465Z'
          fill='#4568A5'
        />
      </mask>
      <g mask='url(#mask1_12_210)'>
        <g
          style={{ mixBlendMode: 'darken' }}
          opacity='0.3'
          filter='url(#filter1_f_12_210)'
        >
          <ellipse
            cx='1.00183'
            cy='16.6301'
            rx='7'
            ry='14'
            transform='rotate(-23.4996 1.00183 16.6301)'
            fill='black'
          />
        </g>
      </g>
      <circle cx='16' cy='18' r='13' fill='#90B0E4' />
      <circle cx='16' cy='18' r='9' fill='#BFD2EF' />
      <circle cx='16' cy='18' r='5' fill='#F4F8FC' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M30.2082 7.68209L29.7894 7.43872L19.7734 16.6894L28.1739 24.0015C29.4978 25.154 29.9887 26.8346 29.4767 28.7448L30.2082 28.3215C30.7537 28.0051 31.2066 27.5499 31.5212 27.0017C31.8358 26.4535 32.001 25.8318 32.0002 25.199V10.7999C32.0002 10.168 31.8346 9.54715 31.52 8.99985C31.2055 8.45255 30.753 7.99807 30.2082 7.68209Z'
        fill='#608BD8'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.5703 20.6375L3.99634 11.6688C2.69166 10.653 2.10286 9.13315 2.37074 7.34692L1.792 7.68213C1.24714 7.99811 0.794689 8.45259 0.480126 8.99989C0.165563 9.54719 -2.5828e-05 10.168 3.12816e-06 10.8V25.2C-0.000829024 25.8327 0.164379 26.4545 0.478982 27.0027C0.793585 27.5509 1.24647 28.0061 1.792 28.3224L5.1072 30.2446L15.5703 20.6375Z'
        fill='#608BD8'
      />
      <mask
        id='mask2_12_210'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='7'
        width='16'
        height='24'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.5703 20.6375L3.99634 11.6688C2.69166 10.653 2.10286 9.13315 2.37074 7.34692L1.792 7.68213C1.24714 7.99811 0.794689 8.45259 0.480126 8.99989C0.165563 9.54719 -2.5828e-05 10.168 3.12816e-06 10.8V25.2C-0.000829024 25.8327 0.164379 26.4545 0.478982 27.0027C0.793585 27.5509 1.24647 28.0061 1.792 28.3224L5.1072 30.2446L15.5703 20.6375Z'
          fill='#608BD8'
        />
      </mask>
      <g mask='url(#mask2_12_210)'>
        <g
          style={{ mixBlendMode: 'lighten' }}
          opacity='0.3'
          filter='url(#filter2_f_12_210)'
        >
          <ellipse
            cx='-3.00001'
            cy='14'
            rx='7'
            ry='14'
            transform='rotate(11.8725 -3.00001 14)'
            fill='white'
          />
        </g>
      </g>
      <mask
        id='mask3_12_210'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='19'
        y='7'
        width='14'
        height='22'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M30.2082 7.68209L29.7894 7.43872L19.7734 16.6894L28.1739 24.0015C29.4978 25.154 29.9887 26.8346 29.4767 28.7448L30.2082 28.3215C30.7537 28.0051 31.2066 27.5499 31.5212 27.0017C31.8358 26.4535 32.001 25.8318 32.0002 25.199V10.7999C32.0002 10.168 31.8346 9.54715 31.52 8.99985C31.2055 8.45255 30.753 7.99807 30.2082 7.68209Z'
          fill='#608BD8'
        />
      </mask>
      <g mask='url(#mask3_12_210)'>
        <g
          style={{ mixBlendMode: 'lighten' }}
          opacity='0.3'
          filter='url(#filter3_f_12_210)'
        >
          <ellipse
            cx='36.1774'
            cy='21.2772'
            rx='7'
            ry='14'
            transform='rotate(-166.007 36.1774 21.2772)'
            fill='white'
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id='filter0_f_12_210'
        x='13.5793'
        y='-0.299377'
        width='42.0095'
        height='51.65'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feGaussianBlur
          stdDeviation='6'
          result='effect1_foregroundBlur_12_210'
        />
      </filter>
      <filter
        id='filter1_f_12_210'
        x='-19.5054'
        y='-8.51147'
        width='41.0144'
        height='50.2831'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feGaussianBlur
          stdDeviation='6'
          result='effect1_foregroundBlur_12_210'
        />
      </filter>
      <filter
        id='filter2_f_12_210'
        x='-22.4331'
        y='-11.7771'
        width='38.8662'
        height='51.5543'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feGaussianBlur
          stdDeviation='6'
          result='effect1_foregroundBlur_12_210'
        />
      </filter>
      <filter
        id='filter3_f_12_210'
        x='16.5867'
        y='-4.41382'
        width='39.1816'
        height='51.3821'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feGaussianBlur
          stdDeviation='6'
          result='effect1_foregroundBlur_12_210'
        />
      </filter>
      <clipPath id='clip0_12_210'>
        <rect width='32' height='36' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
